import mapboxgl from 'mapbox-gl';
// import 'mapbox-gl/dist/mapbox-gl.css';

export default class Maps {
	constructor(el) {

		// API REFERENCES
		// - https://docs.mapbox.com/help/dive-deeper/attribution/

		this.element 	= el
		this.coords		= [el.dataset.lng, el.dataset.lat]
		this.zoom		= el.dataset.zoom

		mapboxgl.accessToken = 'pk.eyJ1IjoidG9tbW9ycmlzMTk4OCIsImEiOiJjbTJscmNmengwZDZ0MmtxdGh6NG9xbWh2In0.66X66N9LMdHVTVHR46WE8Q';
		// mapboxgl.accessToken = 'pk.eyJ1IjoidG9tbW9ycmlzMTk4OCIsImEiOiJjbTJscXZ4N3YwZHBrMmxxeXJwcTRyOHh3In0.JqjJmMxqxNLrM32vyiaudg';
		var map = new mapboxgl.Map({
			container: el,
			style: 'mapbox://styles/mapbox/dark-v11',
			center: this.coords,
			zoom: this.zoom,
			attributionControl: false,
		});

		// var map = L.mapbox.map('map', 'examples.map-8ced9urs', {attributionControl: false});

	}

}
